import React from 'react';
import ReactDOM from 'react-dom';
import SIM from '../../../sim/core';
import Basket from '../basket';
import PriceTypeSelector from '../pricetypeselector';
import BuyingLoader from '../buyingloader';
import GeneralAdmission from '../generaladmission';
import Sidebar from '../sidebar';
import MapHeader from '../header';
import Legend from '../legend';
import fullScreenActions from '../../../actions/fullscreen';
import translate from '../../../utils/translate';
import withDevice from '../../common/withDeviceHOC';

// Temporary for displaying event eligibility info
import EventEligibilityModal from '../errors/event_eligibility_modal';

class Map extends React.Component {
  static propTypes = {
    filters:    React.PropTypes.object.isRequired,
    basket:     React.PropTypes.object.isRequired,
    fullscreen: React.PropTypes.object,
    isMobile:   React.PropTypes.bool
  };

  state = {
    isFilterActive: false
  };

  componentDidMount () {
    fullScreenActions.register('ism', ReactDOM.findDOMNode(this));
  }

  componentWillUnmount () {
    fullScreenActions.deregister('ism');
  }

  toggleFilters = () => {
    this.setState({
      isFilterActive: !this.state.isFilterActive
    });
  };

  renderMapHeader = () => {
    let label = translate('pageTranslations', 'PRICE_CATEGORY_FILTER_ANY_PRICES');

    if (this.props.filters.activeCategory) {
      label = this.props.filters
      .priceCategories[this.props.filters.activeCategory].priceRange;
    }

    if (this.props.fullscreen.activeModule === 'ism') {
      return (
        <MapHeader
          label={label}
          toggleFilters={this.toggleFilters}
          isFilterActive={this.state.isFilterActive} />
      );
    }
  };

  isBasketFull = () => {
    return this.props.basket.count >= this.props.basket.config.ticketLimit;
  };

  isMemberLimitReached = () => {
    if (this.props.basket.config.memberTicketLimit === false) {
      return false;
    }

    if (this.props.basket.config.memberTicketLimit === 0) {
      return false;
    }

    return this.props.basket.count >= this.props.basket.config.memberTicketLimit;
  };

  // Temporary for rendering event eligibility info when requested
  renderEventEligibility = () => {
    if (this.props.basket.eventIneligibilityCause != null) {
      return (<EventEligibilityModal {...this.props.basket} />);
    }
  };

  render () {
    const mainProps = { className: 'ism__map' };
    const isFullScreen = this.props.fullscreen.activeModule === 'ism';
    let mapClassName = 'map__content';
    const isBasketFull = this.isBasketFull();

    if (isFullScreen) {
      mainProps.className += ' is-fullscreen';
    }

    if (this.props.basket.count > 0) {
      mapClassName += ' has-basket';
    }

    if (this.props.filters.activeCategory) {
      mainProps['data-pc-' + this.props.filters.activeCategory] = '';
    }
    else {
      mainProps['data-pc-all'] = '';
    }

    if (!isFullScreen && this.props.isMobile) {
      return <div data-component="seatmap-container" />;
    }

    return (
      <div {...mainProps} data-component="seatmap-container">
        {this.renderMapHeader()}
        <div className={mapClassName}>
          <Sidebar {...this.props} isActive={this.state.isFilterActive} />
          <SIM.View />
          <Legend />
          <Basket {...this.props} />
          <PriceTypeSelector
            {...this.props.basket}
            isBasketFull={isBasketFull}
            isMemberLimitReached={this.isMemberLimitReached()} />
          <GeneralAdmission
            {...this.props}
            isBasketFull={isBasketFull}
            isMemberLimitReached={this.isMemberLimitReached()} />
          <BuyingLoader isActive={this.props.basket.isBuying} />
        </div>
        {this.renderEventEligibility()}
      </div>
    );
  }
}

export default withDevice(Map);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/map/index.js